import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex-column"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["for"]
const _hoisted_4 = ["id"]
const _hoisted_5 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.list?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.hasDividerStart)
            ? (_openBlock(), _createElementBlock("hr", _hoisted_2))
            : _createCommentVNode("", true),
          (_ctx.label)
            ? _renderSlot(_ctx.$slots, "label", {
                key: 1,
                id: _ctx.id
              }, () => [
                _createElementVNode("label", {
                  class: "c-gird__label mb-16",
                  for: _ctx.id
                }, _toDisplayString(_ctx.label), 9, _hoisted_3)
              ], true)
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            id: _ctx.id,
            class: "c-grid__grid",
            style: _normalizeStyle({
				marginRight: `-${_ctx.itemMarginRight}`,
				marginBottom: `-${_ctx.itemMarginBottom}`,
				..._ctx.gridStyle,
			})
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
              return (_openBlock(), _createElementBlock("span", {
                key: JSON.stringify(item),
                style: _normalizeStyle({
					width: _ctx.itemWidth,
					height: _ctx.itemHeight,
					marginRight: _ctx.itemMarginRight,
					marginBottom: _ctx.itemMarginBottom,
				})
              }, [
                _renderSlot(_ctx.$slots, "item", { item: item }, undefined, true)
              ], 4))
            }), 128))
          ], 12, _hoisted_4)
        ]))
      : _createCommentVNode("", true),
    (_ctx.hasDividerEnd)
      ? (_openBlock(), _createElementBlock("hr", _hoisted_5))
      : _createCommentVNode("", true)
  ], 64))
}